import React from 'react'

import { useFormContext, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAlegraEspIdentificationTypes } from '@/core/hooks/misc/useAlegraConstants'
import { Label } from '@/shared/components/atoms/Label/Label'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/shared/components/atoms/Select'

import { BillingInformationFormData } from '../BillingInformation.types'

interface AlegraEspFieldsProps {
	isEditMode?: boolean
}

export const AlegraEspFields: React.FC<AlegraEspFieldsProps> = ({
	isEditMode = false,
}) => {
	const { t } = useTranslation('common')
	const {
		control,
		formState: { errors },
	} = useFormContext<BillingInformationFormData>()
	const alegraEspIdentificationTypes = useAlegraEspIdentificationTypes()

	return (
		<div className="flex flex-col gap-2 md:col-span-2">
			<Label htmlFor="alegra_identification_type_esp">
				{t('account.billing_information.alegra_identification_type')} *
			</Label>
			<Controller
				name="alegra_identification_type_esp"
				control={control}
				render={({ field }) => (
					<Select
						value={field.value || ''}
						onValueChange={field.onChange}
						disabled={isEditMode}
					>
						<SelectTrigger
							className="bg-input w-full"
							aria-invalid={!!errors.alegra_identification_type_esp}
						>
							<SelectValue
								placeholder={t(
									'account.billing_information.select_identification_type'
								)}
							/>
						</SelectTrigger>
						<SelectContent>
							{alegraEspIdentificationTypes.map((type) => (
								<SelectItem key={type.value} value={type.value}>
									{type.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				)}
			/>
			{errors.alegra_identification_type_esp && (
				<p className="text-sm text-destructive">
					{errors.alegra_identification_type_esp.message}
				</p>
			)}
		</div>
	)
}
